import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Package } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const CHART_TOOLTIP_STYLE = { background: "#18181b", border: "1px solid #27272a", borderRadius: 4 };
const CHART_LABEL_STYLE = { color: "#fafafa", fontWeight: 600 };
const CHART_ITEM_STYLE = { color: "#fafafa" };
const CHART_TICK_SM = { fill: "#a1a1aa", fontSize: 11 };
const BAR_CHART_MARGIN = { left: 20, right: 20 };

export function GearRevenueSection({ gearData, totalRevenue }) {
  return (
    <Card className="border-border">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-2">
          <Package className="w-4 h-4" /> Revenue by Gear
        </CardTitle>
        <p className="text-xs text-muted-foreground mt-1">Event revenue attributed proportionally to assigned gear</p>
      </CardHeader>
      <CardContent data-testid="revenue-by-gear">
        {gearData.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-10">No gear revenue data — gear must be assigned to events with revenue</p>
        ) : (
          <>
            <ResponsiveContainer width="100%" height={Math.max(200, gearData.length * 36)}>
              <BarChart data={gearData.slice(0, 15)} layout="vertical" margin={BAR_CHART_MARGIN}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(240 3.7% 15.9%)" horizontal={false} />
                <XAxis type="number" tick={CHART_TICK_SM} tickFormatter={(v) => `$${(v / 1000).toFixed(1)}k`} tickLine={false} axisLine={false} />
                <YAxis type="category" dataKey="name" tick={CHART_TICK_SM} width={180} tickLine={false} axisLine={false} />
                <Tooltip contentStyle={CHART_TOOLTIP_STYLE} labelStyle={CHART_LABEL_STYLE} itemStyle={CHART_ITEM_STYLE} formatter={(v) => [`$${v.toLocaleString()}`, "Revenue"]} />
                <Bar dataKey="revenue" fill="#f59e0b" radius={[0, 2, 2, 0]} barSize={20} />
              </BarChart>
            </ResponsiveContainer>
            <Table className="mt-4">
              <TableHeader>
                <TableRow className="bg-secondary/30 hover:bg-secondary/30">
                  <TableHead className="text-xs font-semibold uppercase tracking-wider">Gear Item</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">Revenue</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">Events Used</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">% of Total</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {gearData.map((g, i) => (
                  <TableRow key={g.gear_id} data-testid={`gear-revenue-row-${i}`}>
                    <TableCell className="font-medium text-sm">{g.name}</TableCell>
                    <TableCell className="text-right font-semibold text-sm text-primary">${g.revenue.toLocaleString()}</TableCell>
                    <TableCell className="text-right text-sm text-muted-foreground">{g.events}</TableCell>
                    <TableCell className="text-right text-sm text-muted-foreground">{totalRevenue ? Math.round((g.revenue / totalRevenue) * 100) : 0}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </CardContent>
    </Card>
  );
}
